import { APP_ROUTES } from '@routes/routes.constants';
import * as React from 'react';
import { generatePath, useNavigate, useParams } from 'react-router-dom';

import type { UseInstructorNavigationReturn } from './useInstructorNavigation.types';

export function useInstructorNavigation(): UseInstructorNavigationReturn {
  const navigate = useNavigate();
  const { customerId } = useParams<{ customerId: string }>();

  const navigateToInstructor = React.useCallback(
    (instructorId: string): void => {
      navigate(
        generatePath(APP_ROUTES.MANAGE_INSTRUCTORS_DETAIL, {
          customerId: customerId ?? '',
          instructorId,
        })
      );
    },
    [navigate, customerId]
  );

  const navigateToInstructorsList = React.useCallback((): void => {
    navigate(
      generatePath(APP_ROUTES.MANAGE_INSTRUCTORS_MANAGEMENT, {
        customerId: customerId ?? '',
      })
    );
  }, [navigate, customerId]);

  const navigateToManageInstructorsPanel = React.useCallback((): void => {
    navigate(
      generatePath(APP_ROUTES.MANAGE_INSTRUCTORS_BATCH_MANAGEMENT, {
        customerId: customerId ?? '',
      })
    );
  }, [navigate, customerId]);

  const navigateToApprovalLetterPanel = React.useCallback((): void => {
    navigate(
      generatePath(APP_ROUTES.MANAGE_INSTRUCTORS_APPROVAL_LETTER, {
        customerId: customerId ?? '',
      })
    );
  }, [navigate, customerId]);

  return {
    navigateToInstructor,
    navigateToInstructorsList,
    navigateToManageInstructorsPanel,
    navigateToApprovalLetterPanel,
  };
}
